import {createAsyncThunk} from "@reduxjs/toolkit";
import {setValue} from "./reducers";
import {fetchSearchResults} from "../../api/search/searchApi";

export const getSearchResults = createAsyncThunk('search/fetchSearchResults',
    async (term: string, {dispatch}) => {
        dispatch(setValue({key: 'isLoading', value: true}));
        const data = await fetchSearchResults(term);
        dispatch(setValue({key: 'searchResults', value: data}));
        dispatch(setValue({key: 'isLoading', value: false}));
    }
);

export type SearchActions = ReturnType<
    typeof getSearchResults
>;
